import classNames from 'classnames'

import styles from './DotsLoader.css'

interface Props {
  className?: string
}

function DotsLoader(props: Props) {
  return <div className={classNames(props.className, styles.dots)}>{'\u00a0'}</div>
}

export default DotsLoader
